'use strict';

const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	AssetUploadController = require('../models/asset-upload-controller'),
	GoldAWSApi = require('../models/gold-aws-api'),
	ActivityLog = require('../models/activity-log'),
	S3Api = require('../models/s3-api'),
	S3FileModel = require('../models/s3-file-model'),
	AjaxPromise = require('../models/ajax-promise'),
	GoldFilePicker = require('../models/gold-file-picker'),
	GoldImagePicker = require('../models/gold-image-picker'),
	GoldResourceManager = require('../models/gold-resource-manager'),
	GoldAttachmentPicker = require('../models/gold-attachment-picker'),
	IconEditorController = require('../models/icon-editor-controller'),
	domImageDimensionCalculator = require('../widgets/dom-image-dimension-calculator'),
	GoldDrivePageState = require('../models/gold-drive-page-state'),
	WriterModel = require('../models/writer-model'),
	AttachmentEditorController = require('../models/attachment-editor-controller'),
	CrowdlinkPageController = require('../models/crowdlink-page-controller'),
	NetworkStatusDispatcher = require('../models/network-status-dispatcher'),
	StoryboardModel = require('../models/storyboard-model'),
	StoryboardDimensionProvider = require('../models/storyboard-dimension-provider'),
	StoryboardController = require('../models/storyboard-controller'),
	StoryboardMapMediator = require('../models/storyboard-map-mediator'),
	storyboardFontSize = require('../widgets/storyboard-font-size'),
	FileChangesModel = require('../models/file-changes-model'),
	GoldFileChangesCache = require('../models/gold-file-changes-cache'),
	GoldFileChangesModel = require('../models/gold-file-changes-model'),
	GoldFileHistoryEnvelopeSorter = require('@mindmup/mindmup-common/src/gold-file-history-envelope-sorter'),
	authenticationCrowdlinkStart = require('../features/authentication/authentication-crowdlink-start'),
	defaultMapContent = require('../models/default-map-content'),
	GoldIconPacker = require('../models/gold-icon-packer'),
	GoldAttachmentPacker = require('../models/gold-attachment-packer'),
	GoldIconUnpacker = require('../models/gold-icon-unpacker'),
	GoldAttachmentUnpacker = require('../models/gold-attachment-unpacker'),
	CorsProxyFallbackDownloader = require('../models/cors-proxy-fallback-downloader'),
	progressStart = require('../features/progress/progress-start'),
	ContextMenuModel = require('../models/context-menu-model'),
	mapEditingStart = require('../features/map-editing/map-editing-start'),
	mapViewingStart = require('../features/map-viewing/map-viewing-start'),
	measuresStart = require('../features/measures/measures-start'),
	pageActionsStart = require('../features/page-actions-start'),
	formatNoteToHtml = require('@mindmup/mapjs').formatNoteToHtml,
	GoldFileChangesEnvelopeBuilder = require('@mindmup/mindmup-common/src/gold-file-changes-envelope-builder'),
	clipboardStart = require('../features/clipboard-start'),
	CollaborationModel = require('../models/collaboration-model'),
	ReadOnlyChangesModel = require('../models/read-only-changes-model'),
	ConfirmationSender = require('../models/confirmation-sender'),
	goldSessionsStart = require('../features/gold-sessions-start'),
	uniqueString = require('@mindmup/js-utils/src/unique-string'),
	GoldFileInitialiser = require('../models/gold-file-initialiser'),
	goldFileApi = require('../models/gold-file-api'),
	ciscoWebexStart = require('../features/cisco-webex/cisco-webex-start'),
	cleanNonPrintable = require('@mindmup/js-utils/src/clean-non-printable'),
	removeExtraSpaces = require('@mindmup/js-utils/src/remove-extra-spaces'),
	microsoftTeamsStart = require('../features/microsoft-teams/microsoft-teams-start'),
	MicrosoftAuthShim = require('../models/microsoft-auth-shim'),
	OAuthApi = require('../models/oauth-api');


require('../widgets/contact-link-widget');
require('../widgets/tabbed-section-widget');
require('../widgets/add-measure-widget');
require('../widgets/attachment-editor-widget');
require('../widgets/blob-downloader-link-widget');
require('../widgets/context-disabler-widget');
require('../widgets/download-link-widget');
require('../widgets/context-menu-widget');
require('../widgets/file-name-widget');
require('../widgets/gold-drive-import-widget');
require('../widgets/storyboard-key-handler-widget');
require('../widgets/storyboard-widget');
require('../widgets/icon-editor-widget');

require('../widgets/node-context-widget');
require('../widgets/sidebar-widget');
require('../widgets/search-widget');
require('../widgets/selectable-readonly-input-widget');
require('../widgets/keyboard-color-widget');

/* only on editor pages */
require('../widgets/page-scroll-key-override');
require('../widgets/macify-hotkeys-widget');
require('../widgets/popup-link-widget');
require('../widgets/full-screen-view-widget');
require('../widgets/show-hotkey-widget');
require('../widgets/install-hotkey-widget');
require('../widgets/menu-bar-widget');

require('../widgets/move-to-folder-widget');
require('../widgets/writer-widget');
require('../widgets/splittable-widget');
require('../widgets/file-info-value-toggle-widget');
require('../widgets/file-timestamp-widget');
require('../widgets/crowdlink-signin-widget');

require('../widgets/microsoft-teams-crowdlink-authentication-widget');


module.exports = async function editorAWS() {
	const navigatorShim = new NavigatorShim(),
		editingContext = navigatorShim.getHashStringValue('editingContext'),
		{sharedLinkContext} = navigatorShim.getQueryStringAsMap(),
		goldPageState = new GoldDrivePageState(config, navigatorShim),
		activityLog = new ActivityLog(1000),
		storage = navigatorShim.getJsonStorage(),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationCrowdlinkStart({goldApi, context: sharedLinkContext || 'crowdlink'}),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		filePicker = new GoldFilePicker(navigatorShim),
		clientSecret = uniqueString(),
		s3FileModel = new S3FileModel(config, authentication, goldApi, s3Api, navigatorShim, defaultMapContent, {useWatermark: true, clientSecret}),
		collaborationModel = new CollaborationModel(),
		goldResourceManager = new GoldResourceManager(s3FileModel, domImageDimensionCalculator, goldPageState, collaborationModel),
		mapViewing = mapViewingStart(config, activityLog, navigatorShim, collaborationModel, goldResourceManager.getResource),
		imagePicker = new GoldImagePicker(filePicker, goldPageState, goldResourceManager),
		attachmentPicker = new GoldAttachmentPicker(filePicker, goldPageState, goldResourceManager),
		version = navigatorShim.getMMVersion(),
		mapEditing = mapEditingStart(Object.assign({config, ajaxPromise, storage, version, imagePicker}, mapViewing)),
		progress = progressStart(mapViewing.mapModel, imagePicker, goldResourceManager.calculateImageDimensions, mapEditing.colorPickerModel, false, goldResourceManager.getResource),
		iconEditorController = new IconEditorController(mapViewing.mapModel, imagePicker, goldResourceManager.calculateImageDimensions),
		container = document.querySelector('mapeditor'),
		writerModel = new WriterModel(mapViewing.collaborationModel, mapViewing.mapModel, 'note'),
		attachmentEditorController = new AttachmentEditorController(mapViewing.mapModel, attachmentPicker, navigatorShim, writerModel, {resourceManager: goldResourceManager}),
		corsProxyFallbackDownloader = new CorsProxyFallbackDownloader(config, navigatorShim, ajaxPromise, '/assets/image-placeholder.svg'),
		networkStatusDispatcher = new NetworkStatusDispatcher(config, navigatorShim),
		goldFileChangesCache = new GoldFileChangesCache(),
		envelopeBuilder = new GoldFileChangesEnvelopeBuilder(authentication.authenticationModel, mapViewing.collaborationModel.getLocalSessionId),
		goldSessions = goldSessionsStart({config, navigatorShim, authenticationModel: authentication.authenticationModel, goldApi, mapModel: mapViewing.mapModel}),
		goldFileChangesModel = new GoldFileChangesModel({collaborationModel: mapViewing.collaborationModel, s3FileModel, pageState: goldPageState, navigatorShim, networkStatusDispatcher, resourceManager: goldResourceManager, goldFileChangesCache, envelopeBuilder, goldFileHistoryEnvelopeSorter: new GoldFileHistoryEnvelopeSorter()}, {disableReupload: true, goldSessionModel: goldSessions.goldSessionModel, webSocketShim: goldSessions.webSocketShim}),
		goldFileInitialiser = new GoldFileInitialiser({config, pageState: goldPageState, goldFileApi, s3FileModel, collaborationModel: mapViewing.collaborationModel, resourceManager: goldResourceManager, navigatorShim, goldFileChangesModel}),
		goldPageController = new CrowdlinkPageController({authenticationModel: authentication.authenticationModel, goldFileInitialiser}),
		measures = measuresStart(config, mapViewing.collaborationModel, mapViewing.mapModel, navigatorShim),
		storyboardModel = new StoryboardModel(mapViewing.collaborationModel, 'storyboards', 'storyboard-scenes'),
		storyboardDimensionProvider = new StoryboardDimensionProvider(storyboardFontSize, goldResourceManager),
		storyboardController = new StoryboardController(storyboardModel, mapViewing.mapModel),
		storyboardMapMediator = new StoryboardMapMediator(mapViewing.mapModel, storyboardController),
		readOnlyChangesModel = new ReadOnlyChangesModel({collaborationModel: mapViewing.collaborationModel, goldSessionModel: goldSessions.goldSessionModel, s3FileModel, pageState: goldPageState}),
		fileChangesModel = new FileChangesModel(goldPageController, mapViewing.collaborationModel, readOnlyChangesModel /*unsavedChangesModel*/, goldFileChangesModel),
		assetUploadController = new AssetUploadController(goldResourceManager, {skipConfirmation: true}),
		clipboard = clipboardStart(mapViewing.mapModel, mapViewing.mapThemeModel, {
			packers: [
				new GoldIconPacker(goldResourceManager, goldPageState),
				new GoldAttachmentPacker(goldResourceManager, goldPageState)
			],
			unpackers: [
				new GoldIconUnpacker(corsProxyFallbackDownloader, {pageState: goldPageState}),
				new GoldAttachmentUnpacker(navigatorShim, goldPageState),
				assetUploadController
			],
			goldFileChangesModel
		}, navigatorShim),
		contextMenuModel = new ContextMenuModel(mapViewing.mapModel),
		confirmationSender = new ConfirmationSender({storage, goldApi, authenticationModel: authentication.authenticationModel, source: navigatorShim.getHostName()}),
		fileId = navigatorShim.getQueryStringAsMap().fileId,
		components = Object.assign({
			assetUploadController,
			attachmentEditorController,
			fileChangesModel,
			confirmationSender,
			contextMenuModel,
			goldPageState,
			goldFileChangesModel,
			iconEditorController,
			navigatorModel: navigatorShim,
			networkStatusDispatcher,
			pageController: goldPageController,
			s3FileModel,
			storyboardMapMediator,
			storyboardModel,
			storyboardController,
			writerModel
		}, goldSessions, authentication, mapEditing, mapViewing, /*mapExports, */ progress, /*historyView,*/ clipboard, /*fileImport,*/ measures);
	mapViewing.collaborationModel.addEventListener('newSession', () => confirmationSender.confirm('map-loaded'));
	pageActionsStart(components, container);
	window.components = components;

	goldPageController.addEventListener('ready', () => {
		const idea = mapViewing.collaborationModel.getActiveContent();
		mapViewing.mapModel.setIdea(idea);
		progress.progressModel.bindContentListeners();
		mapViewing.mapModel.focusAndSelect(idea.getDefaultRootId());
	});


	//widgets
	if (editingContext) {
		mmWidgets('body').addClass(editingContext);
	}

	mmWidgets('[data-mm-hotkey]').macifyHotkeys(navigatorShim);

	mmWidgets('body').splittableWidget(mapEditing.splittableModel, mapViewing.mapModel, true);
	if (navigatorShim.isMobile()  && navigatorShim.isTouch()) {
		mmWidgets('body').addClass('touchdevice');
	}
	mmWidgets('[data-mm-role="iconEditorWidget"]').iconEditorWidget(iconEditorController, goldResourceManager.getResource);
	mmWidgets('[data-mm-role="file-name"]').fileNameWidget(goldPageController, goldFileChangesModel, {readOnly: true});

	mmWidgets('[data-mm-role="attachmentEditorWidget"]').attachmentEditorWidget(attachmentEditorController);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);


	components.domMapController = mapViewing.initialiseWidgets(container, goldSessions, mapEditing.splittableModel);
	components.log = [];
	// components.log.push({editingContext, editingContextComponents});
	if (sharedLinkContext === 'cisco') {
		components.ciscoWebex = ciscoWebexStart({config, navigatorShim, ciscoWebexContainer: window, s3FileModel, defaultMapContent, authenticationModel: authentication.authenticationModel, goldApi});
	} else if (sharedLinkContext === 'msteams') {
		const {microsoftTeamsModel} = microsoftTeamsStart({config, s3Api, navigatorShim, storage, goldApi, ajaxPromise}),
			microsoftAuthShim = new MicrosoftAuthShim({
				client_id: config.microsoftAppId,
				scope: 'User.Read openid profile Channel.ReadBasic.All'
			}, navigatorShim, ajaxPromise),
			microsoftOAuthApi = new OAuthApi(microsoftAuthShim);
		Object.assign(components, {microsoftTeamsModel, microsoftOAuthApi});
	}

	mapEditing.initialiseWidgets({
		stage: mmWidgets('[data-mapjs-role=stage]'),
		domMapController: components.domMapController,
		navigatorShim,
		domImageDimensionCalculator,
		pageState: goldPageState,
		resourceManager: assetUploadController,
		urlDownloader: corsProxyFallbackDownloader
	});


	goldSessions.initialiseWidgets();

	mmWidgets('mapmenu').menuBarWidget(navigatorShim);
	mmWidgets('[data-mm-node-context]').nodeContextWidget(mapViewing.mapModel);
	mmWidgets('a[download]').downloadLinkWidget(navigatorShim);

	mmWidgets('[data-mm-show-hotkey]').showHotkeyWidget(mmWidgets(document));
	mmWidgets('contextmenu[data-mm-role~="node-context"]').contextMenuWidget(contextMenuModel, mmWidgets('mapeditor'), mmWidgets('body'));
	mmWidgets('contextmenu[data-mm-role~="writer-context"]').contextMenuWidget(new ContextMenuModel(writerModel), mmWidgets('#writer'), mmWidgets('body'), {smallContexts: ['contextMenuRequested']});

	mmWidgets('[data-mm-role=keyboard-color]').keyboardColorWidget(mapViewing.mapModel, mapEditing.mapEditorModel, mapViewing.themeProvider);
	mmWidgets('#searchWidget').searchWidget(mapViewing.mapModel);

	mmWidgets('[data-mm-role~="popup-link"]').popupLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=selectable-read-only]').selectableReadOnlyInputWidget();
	mmWidgets('[data-mm-role~=full-screen-view]').fullScreenControlWidget(navigatorShim);
	mmWidgets('tabbedsection').tabbedSectionWidget();
	mmWidgets('[data-mm-sidebar-name]').sidebarWidget(mapEditing.splittableModel);


	mmWidgets('#writer').writerWidget(writerModel, mapEditing.splittableModel, formatNoteToHtml);

	mmWidgets('[data-mm-install-hotkey]').installHotkeyWidget();
	mmWidgets('[data-mm-context-menu-context]').contextDisablerWidget(contextMenuModel, 'context', 'data-mm-context-menu-context');
	mmWidgets('[data-mm-storyboard-context]').contextDisablerWidget(storyboardController, 'storyboardContext', 'data-mm-storyboard-context');
	mmWidgets('[data-mm-file-info-toggle]').fileInfoValueToggleWidget(goldPageController);
	mmWidgets('[data-mm-writer-context]').contextDisablerWidget(writerModel, 'writerContext', 'data-mm-writer-context');
	mmWidgets('[data-mm-themes-context]').contextDisablerWidget(mapViewing.mapThemeModel, 'themesContext', 'data-mm-themes-context');
	mmWidgets('[data-mm-argument-mapping-context]').contextDisablerWidget(mapEditing.argumentMappingModel, 'argumentMappingContext', 'data-mm-argument-mapping-context');

	mmWidgets('mapeditor').storyboardKeyHandlerWidget(storyboardController, storyboardModel, mapViewing.mapModel, '+');
	mmWidgets('[data-mm-role~=blob-downloader-link]').blobDownloaderLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=blob-tab-loader-link]').blobDownloaderLinkWidget(navigatorShim, true);
	mmWidgets('[data-mm-role~=file-timestamp]').fileTimestampWidget(goldFileChangesModel);
	mmWidgets('[data-mm-role~="crowdlinkSignin"]').crowdlinkSigninWidget({crowdlinkAuthenticator: authentication.crowdlinkAuthenticator, fileId});


	goldPageController.addEventListener('fileInfo', fileInfo => {
		const canEdit = !!(fileInfo?.allowedActions?.uploadChanges);
		mapViewing.mapModel.setEditingEnabled(canEdit);
		if (!canEdit) {
			mmWidgets('body').addClass('readonly');
		}
		mmWidgets('#storyboard').storyboardWidget(storyboardController, storyboardModel, storyboardDimensionProvider, storyboardMapMediator, mapEditing.splittableModel, {readOnly: !canEdit});
		measures.initialiseWidgets({readOnly: !canEdit});
	});


	window.components = components;
	clipboard.initialiseWidgets();
	authentication.authenticationModel.dispatchEvent('not-authenticated');
	if (sharedLinkContext === 'cisco') {
		try {
			await components.ciscoWebex.ciscoWebexShim.init();
			components.ciscoWebex.ciscoWebexShim.addEventListener('shareStateChanged', isShared => {
				if (!isShared) {
					components.navigatorModel.redirect('/cisco-webex.html');
				}
			});
			const ciscoUser = await components.ciscoWebex.ciscoWebexShim.getCiscoUser(),
				displayName = ciscoUser?.displayName || 'redacted',
				displayNameSane = removeExtraSpaces(cleanNonPrintable(displayName)).replace(/[\r\n]/g, ' ').trim();
			await components.crowdlinkAuthenticator.authenticate({fileId, displayName: displayNameSane, externalContextId: ciscoUser.token});
		} catch (e) {
			components.pageController.dispatchEvent('error', e);
		}
	}  else if (sharedLinkContext === 'msteams') {
		//components.microsoftTeamsModel.initialisationComplete();
		mmWidgets('[data-mm-role~="microsoft-teams-authentication-widget"]').microsoftTeamsCrowdlinkAuthenticationWidget(Object.assign({fileId}, components));
	} else {
		mmWidgets('[data-mm-role~="crowdlinkSignin"]').removeClass('hidden');
	}



};
